import { axiosInstance } from '@src/configs/axios.configs';
import { IResponse } from '@src/interfaces/axios.interfaces';

import {
  ISettingsWebDomanRequest,
  ISettingsWebDomanResponse,
} from '../types/settings.types';

export const settingsService = {
  webDomain: (
    params: ISettingsWebDomanRequest,
  ): IResponse<ISettingsWebDomanResponse> =>
    axiosInstance.get('api/settings/web/domain', { params }),
};
